/* tslint:disable:max-line-length */
import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'
import { forEach } from 'lodash'

Vue.use(VueI18n)


const messages: LocaleMessages = {
  en: {
    message: {
      login: 'Log In',
      username: 'Username',
      password: 'Password',
      loggingIn: 'Logging in',
      loginError: 'Username or password is invalid!',
      notFound: 'Page not found',
      sorry: 'Sorry. We were unable to find the page you requested.',
      goHome: 'Go home',
      copyright: '<span class="d-inline-block">Powered by &copy; <a href="https://www.splicesoftware.com">SPLICE Software Ltd.</a> {0}.</span> <span class="d-inline-block">All rights reserved.</span>',
      lastCheckIn: 'Last Checked In',
      never: 'Never',
      phone: 'Phone',
      mobile: 'Mobile'
    }
  },
  fr: {
    message: {
      login: 'Se connecter',
      username: 'Nom d\'utilisateur',
      password: 'Mot de passe',
      loggingIn: 'Se connecter',
      loginError: 'Le nom d\'utilisateur ou le mot de passe n\'est pas valide!',
      notFound: 'Page non trouvée',
      sorry: 'Pardon. Nous n\'avons pas trouvé la page que vous avez demandée.',
      goHome: 'Rentrer chez soi',
      copyright: '<span class="d-inline-block">Propulsé par &copy; <a href="https://www.splicesoftware.com">SPLICE Software Ltd.</a> {0}.</span> <span class="d-inline-block">Tous droits réservés.</span>',
      lastCheckIn: 'Dernière vérification',
      never: 'Jamais',
      phone: 'Téléphone',
      mobile: 'Cellulaire'
    }
  }
}

export const LOCALES = Object.freeze(Object.keys(messages))
export const DEFAULT_LOCALE = LOCALES[0]

const defaultI18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages
})

export const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE
})

export function setLocale (locale: string) {
  // Set the i18n objects locale
  defaultI18n.locale = locale
  i18n.locale = locale;

  // Set the lang on the document html
  (document.querySelector('html') as HTMLHtmlElement).lang = locale

  // Return the set locale
  return locale
}

/**
 * Checks if the given locale is supported.
 *
 * @param locale The locale string to validate.
 */
export function supportedLocale (locale: string) {
  return LOCALES.includes(locale)
}

export function clearMessages () {
  for (const locale of i18n.availableLocales) {
    i18n.setLocaleMessage(locale, {})
  }
}

/* tslint:disable-next-line:no-shadowed-variable */
export function setMessages (messages: LocaleMessages) {
  forEach(messages, (message, locale) => {
    i18n.setLocaleMessage(locale, message)
  })
}


export default defaultI18n
